import axios from "axios";
import { API } from "./apiClient";

const http = axios.create({ baseURL: API, withCredentials: true });

export const REPORT_CATEGORIES = [
  { value: "INCORRECT_INFO", label: "Incorrect information" },
  { value: "SPAM", label: "Spam" },
  { value: "ABUSE", label: "Abuse or harassment" },
  { value: "INAPPROPRIATE", label: "Inappropriate content" },
  { value: "COPYRIGHT", label: "Copyright concern" },
  { value: "SAFETY", label: "Safety concern" },
  { value: "OTHER", label: "Other" },
];

export const emptyReportForm = () => ({
  category: "INCORRECT_INFO",
  details: "",
  contactName: "",
  contactEmail: "",
});

export const normalizeReportInput = ({ targetType, targetId, form }) => ({
  target_type: targetType,
  target_id: String(targetId || "").trim(),
  category: form.category,
  details: form.details.trim() || null,
  contact_name: form.contactName.trim() || null,
  contact_email: form.contactEmail.trim() || null,
});

export const validateReportInput = (input) => {
  if (!input.target_id) return "Missing report target";
  if (!REPORT_CATEGORIES.some((entry) => entry.value === input.category)) return "Choose a valid report category";
  if (input.contact_email && !/^\S+@\S+\.\S+$/.test(input.contact_email)) return "Enter a valid email address";
  return null;
};

export async function submitReport(input) {
  const response = await http.post("", {
    query: `mutation SubmitReport($input: ReportInput!) {
      submitReport(input: $input) { id status submitted_at }
    }`,
    variables: { input },
  });
  if (response.data.errors?.length) throw new Error(response.data.errors[0].message);
  return response.data.data.submitReport;
}
